<template>
	<splash v-show="isLoading" :title="title" />
	<splash v-show="isProc" title="잠시만 기다려 주세요." />
	<studyHeader v-if="!isLoading" />
	<q-page-container v-if="!isLoading">
		<q-page class="pd_all_16" style="height: calc(100vh - 9.83vmin)">
			<div class="row">
				<div class="col passage">
					<qbankHeaderVue
						:questionHeader="questionHeader"
						:inputIdx="inputIdx"
						:bookNm="bookNm"
						@isChangeHeader="
							() => {
								isChangeHeader = true;
							}
						"
					/>
				</div>
				<div class="col answer">
					<!-- <qbankProblem :p-content="problem" v-if="tab === item.index" @setCheckedAnswer="setCheckedAnswer"
            @onChangeProblems="onChangeProblems" @setProblemResult="setProblemResult" /> -->
					<q-scroll-area
						v-if="!relationDialog"
						ref="scrollAreaRef"
						visible
						style="height: calc(100% - 1.99vmin)"
						class="answer__scroll"
					>
						<div>
							<problemChoice
								:p-content="problem"
								v-if="problem"
								@setAnswer="setAnswer"
							/>
						</div>
						<!-- 정답표기 -->
						<div v-if="visibleAnswer">
							{{
								problems[problemOrder]?.data.content.solution.answer.detail[0]
									.answer
							}}
						</div>
						<div>
							<qbankAnswer
								:p-content="problem"
								v-if="
									isScored &&
									problem?.data &&
									problem?.result &&
									problem?.result?.marking !== 'halfWrong'
								"
								@onIntersection="onIntersection"
								@setVideoStatus="setVideoStatus"
							/>
						</div>
					</q-scroll-area>
					<div v-if="relationDialog">
						<ProblemRelation
							:p-content="problem"
							v-if="problem"
							@setRelationAnswer="setRelationAnswer"
							@onClose="
								() => {
									relationDialog = false;
								}
							"
							@setMessage="
								m => {
									msg = m;
								}
							"
						/>
					</div>
					<modalLayer v-if="store.visibleModal" width="400px">
						<div
							style="font-size: x-large; font-weight: bold; text-align: center"
						>
							채점 결과
						</div>
						<br />
						<div style="padding: 0px 20px">
							<div
								v-bind:key="index"
								v-for="(item, index) in resultData.data"
								style="
									display: flex;
									padding: 10px 20px;
									border-radius: 8px;
									background-color: #f7f7f7;
									margin-top: 5px;
									position: relative;
								"
							>
								<AnswerMarking :marking-class="'marking-' + item.marking" />
								<div style="padding: 0px 20px 0px 12px">{{ item.no }}.</div>
								<div>{{ item.analysis }} / &nbsp;</div>
								<div>{{ item.difficult }}</div>
							</div>
						</div>
						<div
							style="margin: 10px 0px; font-weight: bold; text-align: center"
						>
							{{
								resultData?.right && resultData?.right !== 0
									? resultData?.right + '개의 정답'
									: ''
							}}{{
								resultData?.right &&
								resultData?.right !== 4 &&
								resultData?.right !== 0
									? ','
									: ''
							}}
							{{
								resultData?.wrong && resultData?.wrong !== 0
									? resultData?.wrong + '개의 오답'
									: ''
							}}을 받았어요.<br />
							정답, 오답 문제를 확인해봐요.
						</div>
						<div style="text-align: center">
							<cqBtn
								@onClickFn="
									() => {
										// problemOrder = 1; problem = problems[1];
										notiType = 'first';
										nextStep(false, 1);
										isScored = true;
										store.visibleModal = false;
									}
								"
								:options="{ sound: 'next' }"
								color="primary"
								label="채점 확인하기"
							/>
						</div>
					</modalLayer>
				</div>
			</div>
		</q-page>
		<FloatingNotify
			:text="msg"
			:icon="msgIcon"
			@resetMsg="
				() => {
					msg = '';
				}
			"
		/>
		<!-- <FloatingBtn :visible="nextBtn" @on-click="() => { nextBtnAction(); }" /> -->

		<FloatingBtn
			:visible="nextBtn"
			:text="nextBtn && isCompleteBtn ? '본격독해 완료' : null"
			:bgColor="nextBtn && isCompleteBtn ? '#222222' : null"
			:icon="nextBtn && isCompleteBtn ? 'done' : null"
			@on-click="
				() => {
					nextBtn && nextBtnAction();
				}
			"
			:class="nextBtn && isCompleteBtn ? 'answer--txt' : 'answer--next'"
		/>
		<FloatingBtn
			:visible="preBtn"
			position="left"
			@on-click="onClickPreBtn"
			class="answer--prev"
		/>
		<FloatingBtn
			:visible="scoreBtn"
			text="정답 확인"
			text-only="true"
			bgColor="#FF4E7C"
			@on-click="
				() => {
					scoreBtn && setQuestionsResult();
				}
			"
			class="answer--txt"
			bottom="calc( 15.83vmin - 4.9vw - 0.83vmin )"
		/>
	</q-page-container>
</template>

<script setup>
import { historyBack } from '@/helpers/utils';
import splash from '@/components/template/splash.vue';
import { ref, onMounted, onUnmounted, watch, toRaw, computed } from 'vue';
import { DialogStore } from '@/store/modules/dialog';
import modalLayer from '@/components/layouts/layer/modalLayer.vue';
import qbankHeaderVue from '@/components/qbank/header.vue';
import problemChoice from '@/components/qbank/problemChoice.vue';
import qbankAnswer from '@/components/qbank/qbankAnswer.vue';
import AnswerMarking from '@/components/qbank/answerMarking.vue';
import studyHeader from '@/components/layouts/header/studyHeader.vue';
import wordCahrt from '@/components/chart/wordCahrt.vue';
import { getKrtExam, getKrtProblem } from '@/api/modules/qbank';
import dataToParse from '@/helpers/qbankParser/dataParse';
import {
	getHeaderTitle,
	getKreadScore,
	getHeaderText,
	getEtcInfo,
	getHeader,
} from '@/helpers/qbankParser/qbankDataParse';
import { useQuasar } from 'quasar';
import moment from 'moment';
import { soundEffect, soundTic } from '@/helpers/soundEffect';
import { StudyStore } from '@/store/modules/study';
import { useRouter, useRoute } from 'vue-router';
import cqBtn from '@/components/quasar/cqBtn.vue';
import _ from 'lodash';
import ProblemRelation from '@/components/qbank/problemRelation.vue';
import {
	analysis,
	difficult,
	drill,
	learningType,
} from '@/helpers/qbankParser/qbankMeta';
import {
	getAnswer,
	postAnswer,
	postCornerEnd,
	checkProgress,
} from '@/api/modules/study';
import { postUserJson } from '@/api/modules/login';
import FloatingBtn from '@/components/quasar/floatingBtn.vue';
import FloatingNotify from '@/components/quasar/floatingNotify.vue';
import { monitoringLog } from '@/api/modules/monitoring';

const visibleAnswer = ref(false);
const isLog = true;
const onClickPreBtn = () => {
	preBtn.value && nextStep(false);
};

// 학습준비화면 시간
const $q = useQuasar();
const router = useRouter();
const route = useRoute();
const loadingTime = 1000;
const store = DialogStore();
const studyStore = StudyStore();
const dStore = DialogStore();
const isLoading = ref(null);
const isProc = ref(null);
const title = ref('본격독해 준비중...');
const data = ref(null);
const diffTime = ref(null);
let startTime;
let baseTime;
const time = ref(null);
const questionHeader = ref(null);
const bookNm = ref(null);
const resultData = ref([]);
let allProblems = [];
let notif = null;
let problemMaps = [];
let problems = {};
let baseProblems = {};
let drillProblems = {};
let inputIdx = ref(0);
let answer = ref({});
let tmpAnswer = ref({});
let visibleScoring = false; // 채점 표시

//TODO: 차후 스토어로 변경 필요
let problemOrder = ref(1);
let problem = ref(null);
let notiAnswer = null;
let notiInfo = null;
let notiNav = null;
let notiAdditionalNav = null;
let notiNavBack = null;
let notiScoring = null;
let notiType = 'first';
let isScored = false;
let isDrill = false;
let isAllChecked = false;

const relationDialog = ref(false);
const videoDialog = ref(false);
const resultDialog = ref(false);
const relationId = ref(null);
const scrollAreaRef = ref(null);

const nextBtn = ref(false);
const preBtn = ref(false);
const scoreBtn = ref(false);
const msgComp = ref(false);
const msg = ref('');
const msgIcon = ref(null);
const isChangeHeader = ref(false);
const isCompleteBtn = ref(false);

let isViewMode = false;

let cornerLearningBaseTime = null;
let cornerTime = {
	passageReadStartTs: null,
	passageReadEndTs: null,
	passageReadTime: 0,
	videoViewStartTs: null,
	videoViewEndTs: null,
	videoViewTime: 0,
	cornerLearningStartTs: null,
	cornerLearningEndTs: null,
	cornerLearningTime: 0,
};
let learningDataList = ref([]);

const isLast = () => {
	if (isDrill && Object.keys(problems).length === problemOrder.value) {
		if (
			!relationDialog.value &&
			problems[problemOrder.value]?.result?.marking === 'wrong' &&
			problems[problemOrder.value].relationId !== null
		) {
			return (isCompleteBtn.value = false);
		} else {
			return (isCompleteBtn.value = true);
		}
	} else {
		if (problemOrder.value === 4 && Object.keys(drillProblems).length === 0) {
			return (isCompleteBtn.value = true);
		}
		return (isCompleteBtn.value = false);
	}
};

const initCoreReading = (rs, sdata) => {
	questionHeader.value = null; //2023-11-07 pby 문제 데이터 초기화 추가.
	console.log('auth befor: ' + questionHeader.value);
	isLoading.value = false;
	// isKreadVisible.value = true;
	// store.openModal(true);
	const tmpEtcInfo = getEtcInfo(rs);
	data.value = {
		content: getHeaderText(rs),
		kread: tmpEtcInfo.kread,
		title: tmpEtcInfo.title,
		etcInfo: tmpEtcInfo,
		standardReadingTime: moment('2022-10-01 00:00:00')
			.add(tmpEtcInfo.solveTime, 's')
			.format('m분ss초'),
		solveTime: tmpEtcInfo.solveTime,
	};
	// console.log('initCoreReading');
	// console.log(rs);
	questionHeader.value = getHeader(rs);
	console.log('auth after: ' + questionHeader.value);
	bookNm.value = tmpEtcInfo.bookNm;
	startTime = moment();
	cornerTime.cornerLearningStartTs = moment().format('YYYY-MM-DD HH:mm:ss');
	cornerLearningBaseTime = moment();

	if (isLog)
		console.log(
			'-본격독해-initCoreReading-problemOrder.value-  -  :',
			problemOrder.value
		);
	problems[problemOrder.value]['answerStartTs'] = moment().format(
		'YYYY-MM-DD HH:mm:ss'
	);
	problems[problemOrder.value]['cornerStartTs'] = moment().format(
		'YYYY-MM-DD HH:mm:ss'
	);
	if (!sdata) {
		setTimeout(() => {
			msg.value = '기준문제를 풀어 보세요.';
		}, 1000);
	}
};

const nextStep = (v = true, no = -1) => {
	isProc.value = true;
	soundEffect('next');

	if (
		v &&
		!relationDialog.value &&
		problems[problemOrder.value]?.result?.marking === 'wrong' &&
		problems[problemOrder.value].relationId !== null
	) {
		preBtn.value = false;
		nextBtn.value = false;
		if (!problems[problemOrder.value]['completeYn']) {
			setTimeout(() => {
				msgIcon.value = '';
				msg.value = '문제를 잘 이해했는지 다시 한 번 점검해 보세요.';
			}, 500);
		}
		isProc.value = false;
		return (relationDialog.value = true);
	}
	if (!v && relationDialog.value) {
		preBtn.value = notiType === 'first' && !isDrill ? false : true;
		isCompleteBtn.value = false;
		problem.value = problems[problemOrder.value];
		// notiType !== 'last' ? (nextBtn.value = true) : (nextBtn.value = true);
		// 확인 문제 팝업이 활성화 되었을경우 강제 닫기
		isProc.value = false;
		return (relationDialog.value = false);
	}

	if (relationDialog.value) {
		// 확인 문제 팝업이 활성화 되었을경우 강제 닫기
		relationDialog.value = false;
	}

	if (
		!isScored &&
		!isDrill &&
		no == -1 &&
		problems[problemOrder.value] &&
		problems[problemOrder.value]['result'] === null
	) {
		problems[problemOrder.value]['elapsedTime'] =
			problems[problemOrder.value]['elapsedTime'] +
			moment.duration(moment().diff(startTime)).asMilliseconds();
		problems[problemOrder.value]['answerEndTs'] = moment().format(
			'YYYY-MM-DD HH:mm:ss'
		);
	}

	// ***************현재 프로세스***************
	// problems가 index out of range(로직 개념이 비슷) 가 발생하는 시점이 있음.
	// - 본격독해 끝난 후 드릴 문제를 가져온 후에 problems에 엎어침(drillInit)... 근데 problemOrder는 초기화 해주지 않음.
	// - null 체크만 하고 패스하도록 변경 --> drillInit에서 problemOrder를 1로 변경하면 될 듯하나
	// - problemOrder를 초기화 했을 시 어디에서 사이드이펙트가 발생할 지 소스로 분석이 너무나 어려움
	// - 다음 개발자를 위해 주석 남김. by 2024.03.28 k.u.j

	// error ex) - 본격독해 문제 1~4, 현재 문제위치 4번 -> 드릴문제 조회
	//           - 드릴문제가 3개만 가져옴. problems에 문제 3개를 엎어침
	//           - 그러나 현재 문제위치 4번을 -> 1번이나 정상동작 위치로 변경해주지 않음
	//           - 드릴문제가 3개밖에 없는데 문제위치 4번을 참조하려고 함.
	//           - problemOrder가 치횐되기 전까진 index out of range 영향 받을 수 있음.
	if (
		typeof problems[problemOrder.value] !== 'undefined' &&
		problems[problemOrder.value] !== null
	) {
		problems[problemOrder.value]['cornerStartTs'] = startTime.format(
			'YYYY-MM-DD HH:mm:ss'
		);
		problems[problemOrder.value]['cornerElapsedTime'] = moment
			.duration(moment().diff(startTime))
			.asMilliseconds();
		problems[problemOrder.value]['cornerEndTs'] = moment().format(
			'YYYY-MM-DD HH:mm:ss'
		);
	}

	startTime = moment();

	if (
		no == -1 &&
		problems[problemOrder.value] &&
		problems[problemOrder.value]['result'] !== null &&
		problems[problemOrder.value]['result']['marking'] !== 'halfWrong'
	) {
		problems[problemOrder.value]['completeYn'] = true;
	}

	if (notiType === 'last' && v) {
		if (isDrill) {
			return submitAnswer(problemOrder.value, null, true);
			// return router.push('/vocabularylearning');
		} else {
			return submitAnswer(problemOrder.value, null, true);
			// return router.push('/authenticreading');
		}
	}
	if (no === -1) {
		submitAnswer(problemOrder.value);
	}

	if (no !== -1) {
		problemOrder.value = no;
	} else if (!v) {
		if (problemOrder.value === 1 && isDrill) {
			title.value = '본격독해 준비중...';
			isLoading.value = true;
			drillProblems = problems;
			problems = baseProblems;
			problem.value = problems[4];
			isScored = true;
			isDrill = false;
			notiType = 'last';
			problemOrder.value = 4;
			setTimeout(() => {
				isLoading.value = false;
			}, 1000);
			// return nextStep(false, 4);
		} else {
			problemOrder.value = problemOrder.value - 1;
		}
	} else {
		problemOrder.value = problemOrder.value + 1;
	}

	// Exception Not found problem
	if (!problems[problemOrder.value]) {
		store.openAlertDialog({
			message: `${!v ? '이전' : '다음'} 문항을 찾을 수 없습니다.`,
			buttonText: '확인',
			callback: () => {
				router.push('/learninghome');
			},
		});
		isProc.value = false;
		return;
	}

	if (!problems[problemOrder.value]['answerStartTs']) {
		problems[problemOrder.value]['answerStartTs'] = moment().format(
			'YYYY-MM-DD HH:mm:ss'
		);
	}
	if (!problems[problemOrder.value]['cornerStartTs']) {
		problems[problemOrder.value]['cornerStartTs'] = moment().format(
			'YYYY-MM-DD HH:mm:ss'
		);
	}

	questionHeader.value === null && getHeader(problems[problemOrder.value].data);
	if (problemOrder.value === 1) {
		if (isDrill && Object.keys(problems).length === 1) {
			notiType = 'last';
		} else {
			notiType = 'first';
		}
		store.openModal(false);
	} else if (problemOrder.value === Object.keys(problems).length) {
		notiType = 'last';
	} else {
		notiType = 'middle';
	}

	problem.value = {
		...problems[problemOrder.value],
	};

	if (problems[problemOrder.value].result?.marking === 'halfWrong') {
		msgIcon.value = '';
		msg.value = '다시 한 번 풀어 보세요.';
	}

	if (isDrill && !problems[problemOrder.value]['completeYn']) {
		if (problems[problemOrder.value]['problemClassCode'] === '2') {
			// msgIcon.value = 'img:/assets/images/icon/drill_up.svg';
			// msg.value = '드릴업되어 ' + (difficult[problems[problemOrder.value].etcInfo.difficultCd].label) + '문제가 나왔어요.';
		} else {
			// msgIcon.value = 'img:/assets/images/icon/drill_down.svg';
			// msg.value = '드릴다운되어 ' + (difficult[problems[problemOrder.value].etcInfo.difficultCd].label) + '문제가 나왔어요! ';
		}
	}

	if (problems[problemOrder.value]['completeYn']) {
		preBtn.value = notiType !== 'first' || isDrill ? true : false;
		nextBtn.value = true;
	} else if (isDrill && !problems[problemOrder.value]['completeYn']) {
		preBtn.value = false;
		nextBtn.value = false;
	} else if (problems[problemOrder.value]['answer'] !== null && !isScored) {
		preBtn.value = notiType !== 'first' ? true : false;
		nextBtn.value = notiType !== 'last' ? true : false;
	} else if (!problems[problemOrder.value]['completeYn'] || isScored) {
		preBtn.value = false;
		nextBtn.value = false;
	} else {
		preBtn.value = notiType !== 'first' ? true : false;
		nextBtn.value = notiType !== 'last' ? true : false;
	}

	setScrollPosition();
	isLast();
	isProc.value = false;
};

const loadDrill = async sdata => {
	const tmpData = [];
	let tmpDrillProblems = [];

	let tmpSdataDrills = [];
	let maxAnalysisOrd = 1;
	await Object.entries(problems).forEach(async ([key, item]) => {
		const tmpIsRight = item.answer === item.correct;
		if (tmpIsRight) {
			tmpData.push({
				no: item.analysisOrd,
				marking: 'right',
				analysis: item.data.content.property.analysis.analysisNm,
				difficult:
					difficult[item.data.content.property.analysis.difficultCd].label,
			});
			return (tmpDrillProblems = [
				...tmpDrillProblems,
				...allProblems.filter(i => {
					return (
						i.analysisOrd === item.analysisOrd &&
						Number(i.difficultCd) >
							Number(item.data.content.property.analysis.difficultCd)
					);
				}),
			]);
		} else {
			let tmpArr = _.sortBy(
				[
					...allProblems.filter(i => {
						return (
							i.analysisOrd === item.analysisOrd &&
							Number(i.difficultCd) <
								Number(item.data.content.property.analysis.difficultCd)
						);
					}),
				],
				'difficultCd'
			).reverse();
			if (item.data.content.property.analysis.difficultCd === '03') {
				tmpArr = [
					...allProblems.filter(i => {
						return i.analysisOrd === item.analysisOrd && i.difficultCd === '04';
					}),
				];
			}
			tmpData.push({
				no: item.analysisOrd,
				marking: 'halfWrong',
				analysis: item.data.content.property.analysis.analysisNm,
				difficult:
					difficult[item.data.content.property.analysis.difficultCd].label,
			});
			return (tmpDrillProblems = [...tmpDrillProblems, ...tmpArr]);
		}
		// item.result = { marking: tmpIsRight ? 'right' : 'halfWrong', answer: item.answer };
		// if (!item.answerEndTs) {
		//   item.answerEndTs = moment().format('YYYY-MM-DD HH:mm:ss');
		// }
	});

	// console.log('tmpDrillProblems');
	// console.log(tmpDrillProblems);
	const promises = tmpDrillProblems.map((item, index) => {
		return getKrtProblem(
			{
				version: studyStore.exprVersion,
				problemId: item.problemId,
			},
			r => {
				let pData = {
					problemNo: item.analysisOrd,
					problemId: r.content.problemId,
					analysisOrd: item.analysisOrd,
					etcInfo: getEtcInfo(r),
					data: r,
					elapsedTime: 0,
					answer: null,
					reAnswer: null,
					videoTime: 0,
					relationResult: null,
					result: null, // 채점 여부및 1,2차 정오답
					completeYn: false, // 채점및 풀이 확인 완료여부
					scrollCheck: false, // 해설 끝까지 확인 , 스크롤 하단 갔었는지 체크
					relationId:
						r.content.property.problem?.relations?.length > 0
							? r.content.property.problem?.relations[0].relationId
							: null, // 확인 문제 있는지 여부
					completeVideo: false, // 영상 시청 여부
					correct: r.content.solution.answer.detail[0].answer,
					// videoUrl: null,              // 해설 영상 여부
					videoUrl: r.content.property.problem.listen.includes('mp4')
						? process.env.VUE_APP_DS_QBANK_ASSET_URL +
						  r.content.property.problem.listen
						: null,
					// videoUrl: r.content.property.problem.listen !== '' ? process.env.VUE_APP_DS_QBANK_ASSET_URL + r.content.property.problem.listen : null,
					// videoUrl: 'https://media5jvqbd.fmkorea.com/files/attach/new2/20210301/2063168106/62449231/3424305738/b1b4e7075cece7bf3b0174253e99b524.mp4#t=1, 10',              // 해설 영상 여부
					// drill: problems[item.analysisOrd].result.marking === 'right' ? 'up' : 'down',
					prevLabel:
						difficult[
							problems[item.analysisOrd].data.content.property.analysis
								.difficultCd
						].label,
					problemClassCode:
						problems[item.analysisOrd].result?.marking === 'right' ? '2' : '3',
					baseDifficult: problems[item.analysisOrd].etcInfo.difficultCd,
				};
				if (sdata) {
					const tmpData = [...sdata]
						.filter(i => i.problemId === r.content.problemId)
						.pop();
					if (tmpData) {
						pData = {
							...pData,
							completeYn: tmpData.completeYn,
							elapsedTime: tmpData.elapsedTime,
							answer: tmpData.answer,
							correctYn: tmpData.correctYn,
							reAnswer: tmpData.reAnswer,
							reCorrectYn: tmpData.reCorrectYn,
							// result: { marking: (tmpData.correct === tmpData.answer) ? 'right' : (tmpData.reAnswer === null ? 'halfWrong' : ((tmpData.correct === tmpData.reAnswer) ? 'halfRight' : 'wrong')), answer: tmpData.correct === tmpData.answer ? tmpData.answer : tmpData.reAnswer },
							result: {
								marking:
									tmpData.correct === tmpData.answer
										? 'right'
										: tmpData.reAnswer === null
										? 'halfWrong'
										: tmpData.correct === tmpData.reAnswer
										? 'halfRight'
										: 'wrong',
								answer: tmpData.answer,
								reAnswer: tmpData.reAnswer,
							},
							answerStartTs: tmpData.answerStartTs,
							answerEndTs: tmpData.answerEndTs,
							problemClassCode: tmpData.problemClassCode,
						};
						tmpSdataDrills.push(pData);
						maxAnalysisOrd =
							pData.analysisOrd > maxAnalysisOrd
								? pData.analysisOrd
								: maxAnalysisOrd;
					}
				}

				drillProblems = {
					...drillProblems,
					[index + 1]: pData,
				};
			}
		);
	});

	await Promise.all(promises);

	// console.log('promises');
	// console.log(drillProblems);

	let newDrillProblems = { ...drillProblems };

	const drillProblemSet = p => {
		let tmpArr = {};
		if (p['problemClassCode'] === '2' && !(p.correct === p.answer)) {
			let idx = 1;
			Object.entries(newDrillProblems).forEach(([key, i]) => {
				if (
					i.analysisOrd !== p.analysisOrd ||
					Number(i.etcInfo.difficultCd) <=
						Number(p.data.content.property.analysis.difficultCd)
				) {
					// tmpArr = { ...tmpArr, [idx]: { ...i, problemNo: idx } };
					tmpArr = { ...tmpArr, [idx]: { ...i } };
					idx += 1;
				}
			});
			newDrillProblems = tmpArr;

			// problems = problems.filter(i => { return (i.analysisOrd !== problem.analysisOrd || Number(i.data.content.property.analysis.difficultCd) < Number(problems[item.analysisOrd].data.content.property.analysis.difficultCd)) });
		} else if (p['problemClassCode'] === '3' && p.correct === p.answer) {
			let idx = 1;
			Object.entries(newDrillProblems).forEach(([key, i]) => {
				if (
					i.analysisOrd !== p.analysisOrd ||
					Number(i.data.content.property.analysis.difficultCd) >=
						Number(p.data.content.property.analysis.difficultCd)
				) {
					// tmpArr = { ...tmpArr, [idx]: { ...i, problemNo: idx } };
					tmpArr = { ...tmpArr, [idx]: { ...i } };
					idx += 1;
				}
			});
			newDrillProblems = tmpArr;
			// problems = problems.filter(i => { return (i.analysisOrd !== problem.analysisOrd || Number(i.data.content.property.analysis.difficultCd) > Number(problems[item.analysisOrd].data.content.property.analysis.difficultCd)) });
		}
		return tmpArr;
	};

	if (tmpSdataDrills.length > 0) {
		if (studyStore.currentInfo !== null) {
			let tIdx = 0;
			let nArr = {};
			// console.log(newDrillProblems);
			Object.entries(newDrillProblems).map(([k, i]) => {
				// console.log(k)
				// console.log(i)
				if (i.completeYn) {
					tIdx += 1;
					nArr = { ...nArr, [tIdx]: i };
				}
			});
			newDrillProblems = nArr;
		} else {
			await Promise.all(
				tmpSdataDrills.map((i, index) => {
					return drillProblemSet(i);
				})
			);
		}
		// console.log('$$$$$$$$$$$$$ 1');
		// console.log(newDrillProblems);
		drillProblems = newDrillProblems;
		let lastOrder = 1;
		Object.entries(newDrillProblems).forEach(([key, i]) => {
			if (i.completeYn) {
				lastOrder = Number(key);
			}
		});
		title.value = '드릴문제 준비중...';
		isLoading.value = true;
		baseProblems = problems;
		problems = drillProblems;
		problem.value = drillProblems[lastOrder];
		problemOrder.value = lastOrder;
		isDrill = true;
		notiType =
			Object.keys(drillProblems).length === lastOrder
				? 'last'
				: lastOrder === 1
				? 'first'
				: 'middle';
		scoreBtn.value = false;
		// nextStep(false, 1);
		setTimeout(() => {
			isLoading.value = false;
		}, 1000);
		if (studyStore.currentInfo !== null) {
			notiType = 'last';
			// problem.value = drillProblems[Object.keys(drillProblems).length + 1];
			// problemOrder.value = Object.keys(drillProblems).length + 1;
			// newDrillProblems.filter(i => { return i.answer !== null });
		} else {
			isLast();
		}
	} else {
		// console.log('$$$$$$$$$$$$$ 2');
		if (studyStore.currentInfo !== null) {
			problem.value = problems[4];
			problemOrder.value = 4;
			notiType = 'last';
		}
	}
	// 저장된 드릴문제로 드릴문제를 재구성

	// drillInit();
};
// tttttttttttta
const initExams = (sdata = null, exCode = null) => {
	getKrtExam(
		{
			// version: '1.00.01', examNm: 'KRT_02_17_N_02_C'
			version: studyStore.exprVersion,
			examNm: exCode ? exCode + '_R' : studyStore.process.exam.examCode + '_R',
		},
		async rs => {
			// TODO: store 에 코어리딩 문제 저장
			// rs.examMaps
			if (rs && rs.examMaps) {
				const exId = rs.examIds[0];
				rs.examMaps[exId].forEach(item => {
					if (isLog)
						console.log(
							'-본격독해--initExams- c1111 analysisId:',
							item.property.analysisId,
							analysis[item.property.analysisId]
						);
					if (analysis[item.property.analysisId]) {
						allProblems.push({
							...item,
							analysisOrd: analysis[item.property.analysisId]['ord'],
						});
					}
				});
				if (isLog)
					console.log(
						'-본격독해--initExams- c1111 앞문제만 추출 allProblems:',
						allProblems
					);

				let problemArrId = [];
				const tmpDifficult = studyStore.process.exam.difficult; // 러닝홈에서 대입된 값. getUserMain.  현재의 학습할 부분에 대한 난이도가 객체로 들어가있음. 객체!!!!! not 배열!!!!!
				if (isLog)
					console.log(
						'-본격독해--initExams- c1111 studyStore.process. :',
						studyStore.process
					);
				if (isLog)
					console.log(
						'-본격독해--initExams- c1111 studyStore.process.exam.difficult:',
						studyStore.process.exam.difficult
					);
				if (isLog) console.log('-본격독해--initExams- c1111 sdata:', sdata);

				let sOrder = 0;
				let sIndex = 0;
				let tmpIsDrill = false;
				// 저장 데이터가 있을 경우 이동할 문제 번호 및 채점 상태 체크
				if (sdata) {
					let sdataIdxs = [];
					const tmpData = [...sdata].filter(i => i.answerStatus === 'COMPLETE');
					if (tmpData.length > 0) isScored = true;
					if (isLog)
						console.log('-본격독해--initExams- c1111 isScored:', isScored);

					sdata.forEach((i, index) => {
						if (isScored) {
							if (i.completeYn) sdataIdxs.push(i.problemId);
						} else sdataIdxs.push(i.problemId);
						if (i.problemClassCode !== '1' && !tmpIsDrill) tmpIsDrill = true;
					});

					if (isLog)
						console.log(
							'-본격독해--initExams- c1111 tmpIsDrill, sdataIdxs:',
							tmpIsDrill,
							sdataIdxs
						);

					allProblems.forEach((item, index) => {
						if (isLog)
							console.log(
								'-본격독해--initExams- c1111 sdataIdxs.includes(item.problemId):',
								sdataIdxs.includes(item.problemId)
							);
						if (sdataIdxs.includes(item.problemId)) sOrder = item.problemId;
					});
					if (isLog) console.log('-본격독해--initExams- c1111 sOrder:', sOrder);

					// 기존 코드
					// let sdataIdxs = [];
					// const tmpData = [...sdata].filter((i) => i.answerStatus === 'COMPLETE');
					// if (tmpData.length > 0) {
					//     isScored = true;
					// }
					// sdata.forEach((i, index) => {
					//     if (isScored) {
					//         if (i.completeYn) {
					//             sdataIdxs.push(i.problemId);
					//         }
					//     } else {
					//         sdataIdxs.push(i.problemId);
					//     }
					//     if (i.problemClassCode !== '1' && !tmpIsDrill) {
					//         tmpIsDrill = true;
					//     }
					// });
					// allProblems.forEach((item, index) => {
					//     if (sdataIdxs.includes(item.problemId)) {
					//         sOrder = item.problemId;
					//     }
					// });
				}
				if (isLog)
					console.log('-본격독해--initExams- c1111 allProblems:', allProblems);

				allProblems.forEach(item => {
					const tmpItem = tmpDifficult[item.property.analysisId]; // ex)"03" : key 5077의 값 (난이도)  : studyStore의 difficult의  현재 item의 analysisId와 같은 것의 난이도 !!!! 이 시험지 전체문제에서 이것과 같은 것만 뽑아내기위해!!!!
					if (isLog)
						console.log(
							'-본격독해--initExams- c2222 tmpItem:',
							tmpItem,
							item.difficultCd,
							tmpItem === item.difficultCd,
							item.problemId
						);

					// TODO: 문항 검수용 전체 문제 보기
					// problemArrId.push(item);
					if (tmpItem && tmpItem === item.difficultCd) {
						problemArrId.push(item);
					}
					// const tmpProblemArr = [...allProblems];
					// const item = _.filter(tmpProblemArr, item => { return (item.difficultCd === value && analysis[item.property.analysisId].ord === analysis[key].ord) });
					// item.length > 0 && problemArrId.push(item[0]);
				});

				if (isLog)
					console.log(
						'-본격독해--initExams- c3333 problemArrId:',
						problemArrId
					);

				await Promise.all(
					problemArrId.map((item, index) => {
						return getKrtProblem(
							{
								version: studyStore.exprVersion,
								problemId: item.problemId,
							},
							r => {
								let pData = {
									problemNo: item.analysisOrd,
									problemId: r.content.problemId,
									analysisOrd: item.analysisOrd,
									etcInfo: getEtcInfo(r),
									data: r,
									type: studyStore.process.exam.ln,
									elapsedTime: 0,
									answer: null,
									reAnswer: null,
									videoTime: 0,
									relationResult: null,
									// 하단 네비 조정을 위한 변수
									result: null, // 채점 여부및 1,2차 정오답
									completeYn: false, // 채점및 풀이 확인 완료여부
									scrollCheck: false, // 해설 끝까지 확인 , 스크롤 하단 갔었는지 체크
									relationId:
										r.content.property.problem?.relations?.length > 0
											? r.content.property.problem?.relations[0].relationId
											: null, // 확인 문제 있는지 여부
									// relationId: null,           // 확인 문제 있는지 여부
									completeVideo: false, // 영상 시청 여부
									correct: r.content.solution.answer.detail[0].answer,
									// TODO: 큐뱅크 해설영상 파싱필요
									// videoUrl: null,              // 해설 영상 여부
									videoUrl: r.content.property.problem.listen.includes('mp4')
										? process.env.VUE_APP_DS_QBANK_ASSET_URL +
										  r.content.property.problem.listen
										: null,
									// videoUrl: r.content.property.problem.listen !== '' ? process.env.VUE_APP_DS_QBANK_ASSET_URL + r.content.property.problem.listen : null,
									// videoUrl: 'https://media5jvqbd.fmkorea.com/files/attach/new2/20210301/2063168106/62449231/3424305738/b1b4e7075cece7bf3b0174253e99b524.mp4#t=1, 10',              // 해설 영상 여부
									// videoUrl: process.env.VUE_APP_DS_QBANK_ASSET_URL + '/bank/object/KRT_03_01_L_01_C.mp4',
									problemClassCode: '1',
									cornerStartTs: null,
									cornerEndTs: null,
									cornerElapsedTime: null,
								};

								if (sdata) {
									const tmpData = [...sdata]
										.filter(i => i.problemId === r.content.problemId)
										.pop();
									if (isLog)
										console.log(
											'-본격독해--initExams- c4444  푼거 tmpData:',
											tmpData
										);

									if (tmpData && tmpData.problemClassCode === '1') {
										let tmpResult = {
											marking:
												tmpData.correct === tmpData.answer
													? 'right'
													: tmpData.reAnswer === null
													? 'halfWrong'
													: tmpData.correct === tmpData.reAnswer
													? 'halfRight'
													: 'wrong',
											answer: tmpData.answer,
											reAnswer: tmpData.reAnswer,
										};
										if (isLog)
											console.log(
												'-본격독해--initExams- c4444   결 tmpResult:',
												tmpResult
											);

										pData = {
											...pData,
											completeYn: tmpData.completeYn,
											elapsedTime: tmpData.elapsedTime,
											answer: tmpData.answer,
											correctYn: tmpData.correctYn,
											reAnswer: tmpData.reAnswer,
											reCorrectYn: tmpData.reCorrectYn,
											result: isScored ? tmpResult : null,
											answerStartTs: tmpData.answerStartTs,
											answerEndTs: tmpData.answerEndTs,
											problemClassCode: tmpData.problemClassCode,
											scrollCheck: tmpData.completeYn,
											completeVideo: tmpData.completeYn,
											cornerElapsedTime: tmpData.cornerElapsedTime,
											cornerStartTs: tmpData.cornerStartTs,
											cornerEndTs: tmpData.cornerEndTs,
										};
									}
								}

								problems = {
									...problems,
									[item.analysisOrd]: pData,
								};
								if (isLog)
									console.log(
										'-본격독해--initExams- c5555     problems:',
										index,
										problems
									);

								if (index === 0) {
									initCoreReading(r, sdata);
								}
								if (sOrder === item.problemId) {
									sIndex = item.analysisOrd;
								}
							}
						);
					})
				);

				if (sdata) {
					sIndex = sIndex === 0 ? 1 : sIndex;

					problem.value = problems[sIndex];
					problemOrder.value = sIndex;

					if (sIndex === 4) {
						notiType = 'last';
					} else if (sIndex === 1) {
						notiType = 'first';
					} else {
						notiType = 'middle';
					}

					if (!isScored || problems[sIndex]?.completeYn) {
						sIndex !== 1 && (preBtn.value = true);
						if (problems[4] && problems[4].answer && !isScored) {
							scoreBtn.value = true;
						}
						if (sIndex !== 4 || problems[4]?.completeYn) {
							nextBtn.value = true;
						}
					}

					if (isScored) {
						loadDrill(sdata);
					}
				} else {
					problem.value = problems[1];
					problemOrder.value = 1;
					notiType = 'first';
				}
				// 중간 데이터 불러와서 드릴 학습풀이 중일경우
			}
		}
	);
};

const getIsViewMode = value => {
	let isView = false;
	if (value != null) {
		// 미리보기와 현재 학습이 같을 경우
		if (
			value.examIdx === studyStore.process.examIdx &&
			value.studyTree === studyStore.process.studyTree
		) {
			isView = false;
		} else {
			isView = true;
		}
	}
	return isView;
};

watch(
	() => studyStore.currentInfo,
	newValue => {
		soundEffect('enter');
		// console.log('studyStore.currentInfo');
		isLoading.value = true;
		questionHeader.value = null;
		problems = {};
		baseProblems = {};
		drillProblems = {};
		allProblems = [];
		problemOrder.value = 1;
		scoreBtn.value = false;
		preBtn.value = false;
		nextBtn.value = false;
		isCompleteBtn.value = false;
		isScored = false;
		isDrill = false;
		isViewMode = false;
		title.value = '본격독해';
		// setTimeout(() => { initExams(); }, 1000);

		if (getIsViewMode(newValue)) {
			isViewMode = true;
			isCompleteBtn.value = true;
			getAnswer(
				{
					type: 'earnest',
					data: {
						examName: newValue.exam.examCode,
						learningType: newValue.exam.learningType,
					},
				},
				r => {
					setTimeout(() => {
						initExams(r, newValue.exam.examCode);
					}, 1000);
				}
			);
		} else {
			if (studyStore.process.exam.learningStatus === 'I') {
				getAnswer(
					{
						type: 'earnest',
						data: {
							examName: studyStore.process.exam.examCode,
							learningType: studyStore.process.exam.learningType,
						},
					},
					r => {
						if (r?.length > 0) {
							setTimeout(() => {
								initExams(r);
							}, 1000);
						} else {
							setTimeout(() => {
								initExams();
							}, 1000);
						}
					}
				);
			} else if (studyStore.process.exam.learningStatus === 'C') {
				getAnswer(
					{
						type: 'earnest',
						data: {
							examName: studyStore.process.exam.examCode,
							learningType: studyStore.process.exam.learningType,
						},
					},
					r => {
						if (r?.length > 0) {
							setTimeout(() => {
								initExams(r);
							}, 1000);
						} else {
							setTimeout(() => {
								initExams();
							}, 1000);
						}
					}
				);
			} else if (studyStore.process.exam.learningStatus === 'W') {
				setTimeout(() => {
					initExams();
				}, 1000);
			}
		}
	}
);

const init = () => {
	soundEffect('enter');
	isLoading.value = true;
	scoreBtn.value = false;
	preBtn.value = false;
	nextBtn.value = false;
	// setTimeout(() => { initExams(); }, 1000);

	if (getIsViewMode(studyStore.currentInfo)) {
		isViewMode = true;
		isCompleteBtn.value = true;
		getAnswer(
			{
				type: 'earnest',
				data: {
					examName: studyStore.currentInfo.exam.examCode,
					learningType: studyStore.currentInfo.exam.learningType,
				},
			},
			r => {
				setTimeout(() => {
					initExams(r, studyStore.currentInfo.exam.examCode);
				}, 1000);
			}
		);
	} else {
		if (studyStore.process.exam.learningStatus === 'I') {
			getAnswer(
				{
					type: 'earnest',
					data: {
						examName: studyStore.process.exam.examCode,
						learningType: studyStore.process.exam.learningType,
					},
				},
				r => {
					if (r?.length > 0) {
						setTimeout(() => {
							initExams(r);
						}, 1000);
					} else {
						setTimeout(() => {
							initExams();
						}, 1000);
					}
				}
			);
		} else if (studyStore.process.exam.learningStatus === 'C') {
			getAnswer(
				{
					type: 'earnest',
					data: {
						examName: studyStore.process.exam.examCode,
						learningType: studyStore.process.exam.learningType,
					},
				},
				r => {
					if (r?.length > 0) {
						setTimeout(() => {
							initExams(r);
						}, 1000);
					} else {
						setTimeout(() => {
							initExams();
						}, 1000);
					}
				}
			);
		} else if (studyStore.process.exam.learningStatus === 'W') {
			setTimeout(() => {
				initExams();
			}, 1000);
		}
	}
	// setTimeout(() => { initExams(); }, 1000);
};
onMounted(() => {
	init();
	setTimeout(() => {
		if (isLog) console.log('-본격독해-onMounted-problem- :', problem.value);

		let data = {
			menuName: route.path.split('/').join(''),
			learningTypeCode: learningType[studyStore.process.exam.learningType].code,
			examName: studyStore.process.exam.examCode + '_R',
			groupIndex: studyStore?.suggestionIdx,
		};
		monitoringLog(data, res => {
			console.log('authenticreading monitoringLog API response ===', res);
		});

		if (
			process.env.NODE_ENV === 'local' ||
			process.env.NODE_ENV === 'development' ||
			localStorage.getItem('videoSuperPass')
		) {
			visibleAnswer.value = true;
		}
	}, 1200);
});

const answerNoti = () => {
	notiAnswer !== null && notiAnswer();
	notiAnswer = null;
	scoreBtn.value = true;
};

onUnmounted(() => {
	notiClear();
	isLoading.value = true;
	store.openModal(false);
});

const notiClear = () => {
	notif !== null && notif();
	notiAnswer !== null && notiAnswer();
	notiNav !== null && notiNav();
	notiNavBack !== null && notiNavBack();
	notiAdditionalNav !== null && notiAdditionalNav();
	notif = null;
	notiAnswer = null;
	notiNav = null;
	notiNavBack = null;
	notiAdditionalNav = null;
};

watch(
	() => studyStore.process,
	newValue => {
		isLoading.value = true;
		setTimeout(() => {
			initExams();
		}, 1000);
	}
);

const setAnswer = val => {
	// soundEffect('tic');
	const p = problems[problemOrder.value];
	if (!p) return;
	if (p.result) {
		p.reAnswer = val;
		// answerNoti();
		// setNotiNavigation(problems[problemOrder.value]);
		scoreBtn.value = true;
	} else if (isDrill) {
		p.answer = val;
		scoreBtn.value = true;
		preBtn.value = false;
		nextBtn.value = false;
	} else {
		p.answer = val;
		const tmpAnswerArr = _.filter(problems, item => item.answer === null);
		if (tmpAnswerArr.length === 0) {
			isAllChecked = true;
			scoreBtn.value = true;
		}
		notiType !== 'first' ? (preBtn.value = true) : (preBtn.value = false);
		notiType !== 'last' ? (nextBtn.value = true) : (nextBtn.value = false);
		// setNotiNav(tmpAnswerArr.length === 0);
		// setNotiNavigation(problems[problemOrder.value], tmpAnswerArr.length === 0);
	}
	if (isLog)
		console.log(
			'- --setAnswer-   problems problemOrder: problem',
			problems[problemOrder.value],
			problem.value
		);
};
const setRelationAnswer = (val, isComplete = false) => {
	// soundEffect('tic');
	if (!isComplete) {
		problems[problemOrder.value]['completeYn'] = true;
		problems[problemOrder.value]['relationResult'] = val;
		problem.value.completeYn = true;
		problem.value.relationResult = val;
	}
	if (isLog)
		console.log(
			'- --setRelationAnswer-  isComplete  val  :  ',
			isComplete,
			val
		);

	isLast();
	preBtn.value = true;
	nextBtn.value = true;
	// setNotiNavigation(problems[problemOrder.value]);
};
const nextBtnAction = () => {
	if (isLog) console.log('-본격독해--nextBtnAction- a111  :');

	if (
		!relationDialog.value &&
		problems[problemOrder.value]?.result?.marking === 'wrong' &&
		problems[problemOrder.value].relationId !== null
	) {
		if (isLog) console.log('-본격독해--nextBtnAction- q111:');
		nextStep();
	} else if (
		notiType === 'last' &&
		isScored &&
		!isDrill &&
		Object.keys(drillProblems).length > 0
	) {
		if (isLog) console.log('-본격독해--nextBtnAction- q222:');
		relationDialog.value = false;
		drillInit();
	} else {
		if (isLog)
			console.log('-본격독해--nextBtnAction- q333 isScored:', isScored);
		if (isScored) {
			// problems[problemOrder.value]['completeYn'] = true;
		}
		nextStep();
	}
};

const setQuestionsResult = () => {
	if (isLog) console.log('-본격독해--setQuestionsResult- a111  :');

	// soundEffect('next');
	notiAdditionalNav = null;
	// problems[problemOrder.value]['cornerElapsedTime'] = (isNaN(problems[problemOrder.value]['cornerElapsedTime']) ? 0 : problems[problemOrder.value]['cornerElapsedTime']) + moment.duration(moment().diff(startTime)).asSeconds();
	problems[problemOrder.value]['cornerElapsedTime'] = moment
		.duration(moment().diff(startTime))
		.asMilliseconds();
	problems[problemOrder.value]['cornerEndTs'] = moment().format(
		'YYYY-MM-DD HH:mm:ss'
	);
	if (isDrill) {
		const tmpIsRight =
			problems[problemOrder.value].data.content.solution.answer.detail[0]
				.answer === problems[problemOrder.value].answer;
		if (problems[problemOrder.value]['result'] !== null) {
			if (isLog)
				console.log(
					'-본격독해--setQuestionsResult-드릴두번째 a222  :',
					problems[problemOrder.value]['result']
				);
			const tmp =
				problems[problemOrder.value].data.content.solution.answer.detail[0]
					.answer === problems[problemOrder.value].reAnswer;
			soundEffect(tmp ? 'correct' : 'wrong');
			problems[problemOrder.value]['result'] = {
				marking: tmp ? 'halfRight' : 'wrong',
				answer: problems[problemOrder.value].answer,
			};
			problem.value = { ...problems[problemOrder.value] };
		} else {
			if (isLog)
				console.log(
					'-본격독해--setQuestionsResult- 드릴첫번째 a333  :',
					problems[problemOrder.value]['result']
				);
			if (!problems[problemOrder.value]['answerEndTs']) {
				problems[problemOrder.value]['answerEndTs'] = moment().format(
					'YYYY-MM-DD HH:mm:ss'
				);
			}
			problems[problemOrder.value]['elapsedTime'] =
				problems[problemOrder.value]['elapsedTime'] +
				moment.duration(moment().diff(startTime)).asMilliseconds();
			// startTime = moment();
			if (
				problems[problemOrder.value]['problemClassCode'] === '2' &&
				!tmpIsRight
			) {
				if (isLog)
					console.log(
						'-본격독해--setQuestionsResult- a444 tmpIsRight :',
						tmpIsRight
					);

				let tmpArr = {};
				let idx = 1;
				Object.entries(problems).forEach(([key, i]) => {
					if (
						i.analysisOrd !== problems[problemOrder.value].analysisOrd ||
						Number(i.etcInfo.difficultCd) <=
							Number(
								problems[problemOrder.value].data.content.property.analysis
									.difficultCd
							)
					) {
						// tmpArr = { ...tmpArr, [idx]: { ...i, problemNo: idx } };
						tmpArr = { ...tmpArr, [idx]: { ...i } };
						idx += 1;
					}
				});
				problems = tmpArr;

				if (idx - 1 === problemOrder.value) {
					notiType = 'last';
				}
				// problems = problems.filter(i => { return (i.analysisOrd !== problem.analysisOrd || Number(i.data.content.property.analysis.difficultCd) < Number(problems[item.analysisOrd].data.content.property.analysis.difficultCd)) });
			} else if (
				problems[problemOrder.value]['problemClassCode'] === '3' &&
				tmpIsRight
			) {
				if (isLog)
					console.log(
						'-본격독해--setQuestionsResult- a555 tmpIsRight :',
						tmpIsRight
					);
				let tmpArr = {};
				let idx = 1;
				Object.entries(problems).forEach(([key, i]) => {
					if (
						i.analysisOrd !== problems[problemOrder.value].analysisOrd ||
						Number(i.data.content.property.analysis.difficultCd) >=
							Number(
								problems[problemOrder.value].data.content.property.analysis
									.difficultCd
							)
					) {
						// tmpArr = { ...tmpArr, [idx]: { ...i, problemNo: idx } };
						tmpArr = { ...tmpArr, [idx]: { ...i } };
						idx += 1;
					}
				});
				problems = tmpArr;

				if (idx - 1 <= problemOrder.value) {
					notiType = 'last';
				}
				// problems = problems.filter(i => { return (i.analysisOrd !== problem.analysisOrd || Number(i.data.content.property.analysis.difficultCd) > Number(problems[item.analysisOrd].data.content.property.analysis.difficultCd)) });
			}
			soundEffect(
				problems[problemOrder.value].data.content.solution.answer.detail[0]
					.answer === problems[problemOrder.value].answer
					? 'correct'
					: 'halfWrong'
			);
			problems[problemOrder.value]['result'] = {
				marking:
					problems[problemOrder.value].data.content.solution.answer.detail[0]
						.answer === problems[problemOrder.value].answer
						? 'right'
						: 'halfWrong',
				answer: problems[problemOrder.value].answer,
			};
			if (
				problems[problemOrder.value].data.content.solution.answer.detail[0]
					.answer !== problems[problemOrder.value].answer
			) {
				if (isLog)
					console.log(
						'-본격독해--setQuestionsResult- 드릴첫번째 틀림 a666 problems[problemOrder.value].answer :',
						problems[problemOrder.value].answer
					);
				msgIcon.value = '';
				msg.value = '다시 한 번 풀어 보세요.';
			}
			problem.value = { ...problems[problemOrder.value] };
			if (problemOrder.value >= Object.keys(problems).length) {
				notiType = 'last';
			}
		}
		scoreBtn.value = false;
		isLast();
	} else {
		if (isScored) {
			if (isLog)
				console.log(
					'-본격독해--setQuestionsResult-두번째 a777 isScored :',
					isScored
				);
			soundEffect(
				problems[problemOrder.value].data.content.solution.answer.detail[0]
					.answer === problems[problemOrder.value].reAnswer
					? 'correct'
					: 'wrong'
			);
			problems[problemOrder.value]['result'] = {
				marking:
					problems[problemOrder.value].data.content.solution.answer.detail[0]
						.answer === problems[problemOrder.value].reAnswer
						? 'halfRight'
						: 'wrong',
				answer: problems[problemOrder.value].answer,
			};
			problem.value = { ...problems[problemOrder.value] };
		} else {
			if (isLog)
				console.log('-본격독해--setQuestionsResult- a888 isScored :', isScored);

			isAllChecked = false;
			if (problems[problemOrder.value]['result'] === null) {
				problems[problemOrder.value]['elapsedTime'] =
					problems[problemOrder.value]['elapsedTime'] +
					moment.duration(moment().diff(startTime)).asMilliseconds();
				problems[problemOrder.value]['answerEndTs'] = moment().format(
					'YYYY-MM-DD HH:mm:ss'
				);
			}
			// startTime = moment();
			const tmpData = [];
			let tmpDrillProblems = [];
			Object.entries(problems).forEach(([key, item]) => {
				const tmpIsRight =
					item.data.content.solution.answer.detail[0].answer === item.answer;
				if (tmpIsRight) {
					tmpData.push({
						no: item.analysisOrd,
						marking: 'right',
						analysis: item.data.content.property.analysis.analysisNm,
						difficult:
							difficult[item.data.content.property.analysis.difficultCd].label,
					});
					tmpDrillProblems = [
						...tmpDrillProblems,
						...allProblems.filter(i => {
							return (
								i.analysisOrd === item.analysisOrd &&
								Number(i.difficultCd) >
									Number(item.data.content.property.analysis.difficultCd)
							);
						}),
					];
				} else {
					let tmpArr = _.sortBy(
						[
							...allProblems.filter(i => {
								return (
									i.analysisOrd === item.analysisOrd &&
									Number(i.difficultCd) <
										Number(item.data.content.property.analysis.difficultCd)
								);
							}),
						],
						'difficultCd'
					).reverse();
					if (item.data.content.property.analysis.difficultCd === '03') {
						tmpArr = [
							...allProblems.filter(i => {
								return (
									i.analysisOrd === item.analysisOrd && i.difficultCd === '04'
								);
							}),
						];
					}
					tmpData.push({
						no: item.analysisOrd,
						marking: 'halfWrong',
						analysis: item.data.content.property.analysis.analysisNm,
						difficult:
							difficult[item.data.content.property.analysis.difficultCd].label,
					});
					tmpDrillProblems = [...tmpDrillProblems, ...tmpArr];
				}
				item.result = {
					marking: tmpIsRight ? 'right' : 'halfWrong',
					answer: item.answer,
				};
				// if (!item.answerEndTs) {
				//   item.answerEndTs = moment().format('YYYY-MM-DD HH:mm:ss');
				// }
			});
			const total = _.countBy(tmpData, i => {
				return i.marking === 'right' ? 'right' : 'wrong';
			});

			resultData.value = { ...total, data: tmpData };
			tmpDrillProblems.forEach((item, index) => {
				getKrtProblem(
					{
						version: studyStore.exprVersion,
						problemId: item.problemId,
					},
					r => {
						drillProblems = {
							...drillProblems,
							[index + 1]: {
								// problemNo: index + 1,
								problemNo: item.analysisOrd,
								problemId: r.content.problemId,
								analysisOrd: item.analysisOrd,
								etcInfo: getEtcInfo(r),
								data: r,
								elapsedTime: 0,
								answer: null,
								reAnswer: null,
								// markingType: 'right', //'right': 정답, 'halfWrong':1차오답 , 'halfRight':2차정답 , 'wrong':2차오답
								videoTime: 0,
								relationResult: null,
								// correctiveStatus: false,
								// totalCnt: 0,
								// process: 1,
								// 하단 네비 조정을 위한 변수
								result: null, // 채점 여부및 1,2차 정오답
								completeYn: false, // 채점및 풀이 확인 완료여부
								scrollCheck: false, // 해설 끝까지 확인 , 스크롤 하단 갔었는지 체크
								relationId:
									r.content.property.problem?.relations?.length > 0
										? r.content.property.problem?.relations[0].relationId
										: null, // 확인 문제 있는지 여부
								completeVideo: false, // 영상 시청 여부
								correct: r.content.solution.answer.detail[0].answer,
								// videoUrl: null,              // 해설 영상 여부3
								videoUrl: r.content.property.problem.listen.includes('mp4')
									? process.env.VUE_APP_DS_QBANK_ASSET_URL +
									  r.content.property.problem.listen
									: null,
								// videoUrl: 'https://media5jvqbd.fmkorea.com/files/attach/new2/20210301/2063168106/62449231/3424305738/b1b4e7075cece7bf3b0174253e99b524.mp4#t=1, 10',              // 해설 영상 여부
								// videoUrl: process.env.VUE_APP_DS_QBANK_ASSET_URL + '/bank/object/KRT_03_01_L_01_C.mp4',
								// drill: problems[item.analysisOrd].result.marking === 'right' ? 'up' : 'down',
								prevLabel:
									difficult[
										problems[item.analysisOrd].data.content.property.analysis
											.difficultCd
									].label,
								problemClassCode:
									problems[item.analysisOrd].result.marking === 'right'
										? '2'
										: '3',
								baseDifficult: problems[item.analysisOrd].etcInfo.difficultCd,
								cornerStartTs: null,
								cornerEndTs: null,
								cornerElapsedTime: null,
							},
						};
					}
				);
			});
			isScored = true;
			submitAnswer(problemOrder.value);
			// Object.entries(problems).forEach(([key, item]) => {
			//     submitAnswer(key);
			// });

			// notiClear();
			// problem.value = problems[problemOrder.value];
			// problemOrder.value = 0;
			// problem.value = problems[0];
			// notiType = 'first'
			// resultDialog.value = true;

			// 채점결과화면 제거 1번 문제로 바로이동으로 변경
			store.openModal(true);

			notiType = 'first';
			nextStep(false, 1);
		}
		scoreBtn.value = false;
		preBtn.value = false;
		nextBtn.value = false;
	}
};

// 스크롤 하단시 액션
const onIntersection = () => {
	if (problems[problemOrder.value]['scrollCheck'] !== true) {
		problems[problemOrder.value]['scrollCheck'] = true;
		if (problem.value?.result?.marking === 'right') {
			problems[problemOrder.value]['completeYn'] = true;
			problems[problemOrder.value]['completeVideo'] = true;
			notiType !== 'first' || isDrill
				? (preBtn.value = true)
				: (preBtn.value = false);
			nextBtn.value = true;
		} else if (problem.value?.result?.marking === 'halfRight') {
			if (problems[problemOrder.value]['videoUrl'] === null) {
				problems[problemOrder.value]['completeYn'] = true;
				problems[problemOrder.value]['completeVideo'] = true;
				notiType !== 'first' || isDrill
					? (preBtn.value = true)
					: (preBtn.value = false);
				nextBtn.value = true;
			} else {
				msgIcon.value = '';
				// msg.value = '확인해야 할 해설영상이 있어요!';
				msg.value = '문제풀이 영상을 확인하세요.';
			}
		} else {
			if (problems[problemOrder.value]['videoUrl'] !== null) {
				msgIcon.value = '';
				// msg.value = '확인해야 할 해설영상이 있어요!';
				msg.value = '문제풀이 영상을 확인하세요.';
			} else if (
				problems[problemOrder.value]['videoUrl'] === null &&
				problems[problemOrder.value]['relationId'] === null
			) {
				problems[problemOrder.value]['completeYn'] = true;
				notiType !== 'first' || isDrill
					? (preBtn.value = true)
					: (preBtn.value = false);
				nextBtn.value = true;
			} else if (problems[problemOrder.value]['relationId'] !== null) {
				nextBtn.value = true;
			} else {
				notiType !== 'first' || isDrill
					? (preBtn.value = true)
					: (preBtn.value = false);
				nextBtn.value = true;
			}
		}
		// setNotiNavigation(problems[problemOrder.value]);
	}
};

const setVideoStatus = () => {
	problems[problemOrder.value]['completeVideo'] = true;
	if (problems[problemOrder.value]['relationId'] === null) {
		problems[problemOrder.value]['completeYn'] = true;
		notiType !== 'first' || isDrill
			? (preBtn.value = true)
			: (preBtn.value = false);
	}
	notiType !== 'first' || isDrill
		? (preBtn.value = true)
		: (preBtn.value = false);
	nextBtn.value = true;
	// setNotiNavigation(problems[problemOrder.value]);
};

const setScrollPosition = (val = 0) => {
	if (scrollAreaRef.value) {
		scrollAreaRef.value.setScrollPosition('vertical', 0);
	}
};

const drillInit = () => {
	problems[problemOrder.value]['completeYn'] = true;
	title.value = '드릴문제 준비중...';
	isLoading.value = true;
	baseProblems = problems;
	problems = drillProblems;
	problem.value = drillProblems[1];
	// isScored = false;
	isDrill = true;
	notiType = 'first';
	submitAnswer(4, 'base');
	nextStep(false, 1);
	setTimeout(() => {
		isLoading.value = false;
		setTimeout(() => {
			msg.value = '기준문제 결과에 따른 드릴문제를 풀어 보세요.';
		}, 500);
	}, 1000);
	// problemOrder.value = 1;
};

const saveResult = () => {
	if (isViewMode) {
		router.push('/vocabularylearning');
		studyStore.currentInfo.studyTree = studyStore.currentInfo.studyTree + 1;
	} else {
		const _data = {
			examName: studyStore.process.exam.examCode + '_C',
			learningType: studyStore.process.exam.learningType,
		};
		postCornerEnd(
			{
				type: 'earnest',
				data: _data,
			},
			() => {
				if (isLog) console.log('-본격독해--saveResult- :', problem);

				router.push('/vocabularylearning');
				//studyStore.process.studyTree = studyStore.process.studyTree + 1;

				//2023-11-08 pby 세션 코드 값 전달 변경
				// 5082: '코어독해',
				// 5083: '본격독해',
				// 5086: '본격독해_확인',
				// 5084: '어휘학습',
				studyStore.process.studyTree = 5084;

				// postUserJson(JSON.stringify(studyStore.process), (rs) => {
				//   //
				// });
			}
		);
	}
};

const submitAnswer = (num, target = null, end = false) => {
	if (isLog)
		console.log(
			'-본격독해--submitAnswer- s111 num target end:',
			num,
			target,
			end
		);

	let tmpVal = { ...problems[num] };
	if (isLog) console.log('-본격독해--submitAnswer- tmpVal:', tmpVal);

	let tmpCornerTime;
	if (target === 'drill') {
		tmpVal = { ...drillProblems[num] };
		tmpCornerTime = {
			cornerLearningStartTs: drillProblems[num].cornerStartTs,
			cornerLearningEndTs: drillProblems[num].cornerEndTs,
			cornerLearningTime: drillProblems[num].cornerElapsedTime,
		};
	} else if (target === 'base') {
		tmpVal = { ...baseProblems[num] };
		tmpCornerTime = {
			cornerLearningStartTs: baseProblems[num].cornerStartTs,
			cornerLearningEndTs: baseProblems[num].cornerEndTs,
			cornerLearningTime: baseProblems[num].cornerElapsedTime,
		};
	} else {
		tmpCornerTime = {
			cornerLearningStartTs: problems[num].cornerStartTs,
			cornerLearningEndTs: problems[num].cornerEndTs,
			cornerLearningTime: problems[num].cornerElapsedTime,
		};
	}
	if (tmpVal) {
		tmpVal.reAnswer = tmpVal.reAnswer ? tmpVal.reAnswer : null;
		tmpVal.reviewContents = isChangeHeader.value
			? document.getElementById('header_box')?.innerHTML
			: null;
		tmpVal.correctYn =
			tmpVal.result === null ? null : tmpVal.result?.marking === 'right';
		tmpVal.reCorrectYn =
			tmpVal.reAnswer === null
				? null
				: tmpVal.result?.marking === 'halfRight'
				? true
				: false;
		tmpVal.answerStatus = isScored ? 'COMPLETE' : 'NOT_SCORE';

		delete tmpVal.data;
		delete tmpVal.result;
		delete tmpVal.rightAnswer;

		delete tmpVal.problemNo;
		delete tmpVal.analysisOrd;
		delete tmpVal.etcInfo;
		delete tmpVal.videoTime;
		delete tmpVal.relationResult;
		delete tmpVal.scrollCheck;
		delete tmpVal.relationId;
		delete tmpVal.completeVideo;

		delete tmpVal.videoUrl;
		delete tmpVal.completeVideo;

		delete tmpVal.cornerStartTs;
		delete tmpVal.cornerEndTs;
		delete tmpVal.cornerElapsedTime;

		const saveData = {
			examName: studyStore.process.exam.examCode + '_R',
			exprVersion: studyStore.exprVersion,
			learningType: studyStore.process.exam.learningType,
			cornerTime: tmpCornerTime,
			submission: { ...tmpVal },
		};

		if (!isViewMode) {
			checkProgress(rs => {
				//2023-01-04 pby KRT-2190 추천학습중 맞춤학습 진도가 변경된 경우 학습 알럿 표출 안함
				const learningTypeCodeFlag =
					learningType[studyStore.process.exam.learningType].code;
				if (rs.modifyProgressFlag && learningTypeCodeFlag == '1') {
					dStore.openAlertDialog({
						//2023-12-06 pby KRT-1709 진도수정 기능 개선 기능 추가
						//message: '학습 진도가 ' + (rs.modifyProgressFlag ? '수정' : '리셋') + '되었습니다.\n 다시 학습을 진행해 주세요.',
						//2023-12-11 pby KRT-2153 -- 학습중 진도수정시 알럿 메세지 수정.
						message: '학습 진도가 변경되었습니다. ',
						buttonText: '확인',
						callback: () => {
							//2023-12-06 pby KRT-1709 진도수정 기능 개선 기능 추가
							router.push('/learninghome');
							// sendUserAnswer(end, saveData);
							// postAnswer({ type: 'core', data: saveData }, () => {
							//     studyStore.process.exam.learningStatus = 'I';
							//     if (end) saveResult();
							// });
						},
					});
					//2024-01-04 pby 반영확인
				} else if (rs.modifyProgressFlag && learningTypeCodeFlag == '6') {
					dStore.openAlertDialog({
						//2023-12-06 pby KRT-1709 진도수정 기능 개선 기능 추가
						//message: '학습 진도가 ' + (rs.modifyProgressFlag ? '수정' : '리셋') + '되었습니다.\n 다시 학습을 진행해 주세요.',
						//2023-12-11 pby KRT-2153 -- 학습중 진도수정시 알럿 메세지 수정.
						message:
							'학습 진도가 수정되었습니다. 현재 학습이 끝나면 진도가 변경됩니다.',
						buttonText: '확인',
						callback: () => {},
					});
				} else {
					if (isLog)
						console.log(
							'-본격독해--submitAnswer22222-dddbb saveData:',
							saveData
						);
					sendUserAnswer(end, saveData);
					// postAnswer({ type: 'earnest', data: saveData }, () => {
					//     if (end) saveResult();
					//     studyStore.process.exam.learningStatus = 'I';
					// });
				}
			});
		} else if (end) {
			store.openAlertDialog({
				message: '현재 진행중인 학습으로 이동합니다.',
				cancel: '닫기',
				ok: '확인',
				callback: () => {
					studyStore.currentInfo = null;
					router.push(
						studyStore.process.studyTree === 5083
							? '/authenticreading'
							: studyStore.process.studyTree === 5084
							? '/vocabularylearning'
							: 'corereading'
					);
				},
			});
		}

		cornerTime.cornerLearningStartTs = moment().format('YYYY-MM-DD HH:mm:ss');
	}
};

const sendUserAnswer = (end, saveData) => {
	// if (isLog) console.log('-본격독해--submitAnswer111111-dddbb problem:', problem.value);
	const answer = saveData.submission.answer;
	if (isLog)
		console.log('-본격독해--submitAnswer111111-  dddbb answer:', answer);
	if (!answer) {
		router.go(router.currentRoute);
		return;
	}
	//msg.value = moment(saveData.submission.elapsedTime).format('mm분 ss초');
	postAnswer({ type: 'earnest', data: saveData }, () => {
		if (end) saveResult();
		studyStore.process.exam.learningStatus = 'I';
	});
};
</script>

<style scoped lang="scss">
.word-chart_item {
	padding: 0px 20px;
	text-align: center;
}

.q-dialog__backdrop {
	width: 100vw;
	height: 100vh;
	top: 0px;
	position: fixed;
	z-index: 6000;
	pointer-events: all;
	outline: 0;
	background: rgb(23 20 20 / 40%);
}

::v-deep {
	.answer {
		&--next {
			.q-icon {
				margin: 0 auto;
				font-size: 1.3vw;
			}
		}

		&--prev {
			.q-icon {
				margin: 0 auto;
				font-size: 1.3vw;
			}
		}
	}
}

.passage,
.answer {
	height: calc((var(--vh, 1vh) * 100) - 82px);
	margin-top: 1.99vmin;
}

.passage {
	+ .answer {
		&::before {
			content: '';
			position: absolute;
			top: 46%;
			left: 0;
			width: 1px;
			height: 91%;
			max-height: 974px;
			background: $color_gray_500;
			@include transform(translateY(-50%));
		}
	}
}

.answer {
	position: relative;
	// padding: 0 4.17vmin;

	&__scroll {
		padding: 0 5.17vmin 3.33vmin 4.08vmin;
		// padding-right: 5.17vmin;
		// padding-bottom: 3.33vmin;
	}

	&--next {
		width: 4.9vw;
		height: 4.9vw;
		margin-right: 3.33vmin;
	}

	&--prev {
		width: 3.5vw;
		height: 3.5vw;
		margin-left: 2.5vmin;
	}

	&--txt {
		padding: 2.75vmin 3.42vmin !important;
		margin-right: 3.33vmin;
		font-size: 1.2vw;
		font-weight: 700;
		line-height: 1.6vw;
	}
}

::v-deep {
	.q-scrollarea__content {
		padding-bottom: 3.33vmin;
	}

	.q-scrollarea__bar--v,
	.q-scrollarea__thumb--v {
		width: 0.3vw;
	}
}
</style>
